import { render } from "./FornecedorSelect.vue?vue&type=template&id=480e51e8"
import script from "./FornecedorSelect.vue?vue&type=script&lang=js"
export * from "./FornecedorSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__